<template>
    <div class="row">
        <title>{{ $t("changelog.text_1") }}</title>
        <div class="col-lg-4 col-xl-3">
            <div id="navigation">
                <div class="row">
                    <div class="col-lg-12">
                        <div class="card version">
                            <div
                                class="card-header d-flex justify-content-between align-items-center"
                            >
                                <h5>{{ $t("changelog.text_2") }}</h5>
                                <button
                                    v-if="user"
                                    @click="changelogAlert"
                                    class="btn btn-sm btn-info"
                                >
                                    {{ $t("changelog.text_3") }}
                                </button>
                            </div>
                            <div class="card-block">
                                <ul class="nav navigation">
                                    <li
                                        v-for="log in json"
                                        :key="log.id"
                                        class="waves-effect waves-light"
                                    >
                                        <a :href="'#' + log.id">
                                            {{ $t("changelog.text_4") }}
                                            {{ log.version }}
                                            <span
                                                class="text-muted text-regular pull-right"
                                                >{{ log.date }}</span
                                            >
                                        </a>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-lg-8 col-xl-9">
            <div class="col-sm-12 pt-0">
                <div
                    v-for="log in json"
                    :key="log.id"
                    class="card"
                    :id="log.id"
                >
                    <div class="card-header">
                        <h5>{{ $t("changelog.text_4") }} {{ log.version }}</h5>
                        <div class="">
                            <span class="text-muted heading-text m-r-5">{{
                                moment(log.date, "DD.MM.YYYY")
                                    .locale($i18n.locale)
                                    .format("LL")
                            }}</span>
                            <label class="label label-info">{{
                                $t("changelog.text_5", { version: log.version })
                            }}</label>
                        </div>
                    </div>
                    <div class="card-block change_log" style="display: grid">
                        <span
                            v-for="fnc in log.functions"
                            :key="fnc.id"
                            class="mb-3 d-flex w-100"
                        >
                            <label
                                v-if="fnc.type == 'add'"
                                class="label label-success"
                                >{{ $t("changelog.text_6") }}</label
                            >
                            <label
                                v-if="fnc.type == 'fix'"
                                class="label label-danger"
                                >{{ $t("changelog.text_7") }}</label
                            >
                            <label
                                v-if="fnc.type == 'change'"
                                class="label label-warning"
                                >{{ $t("changelog.text_8") }}</label
                            >
                            <p v-html="fnc.text"></p>
                        </span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import moment from "moment";
import json from "./changelog.json";

export default {
    props: ["user"],
    data() {
        return {
            moment: moment,
            json: json.changelogs,
        };
    },
    methods: {
        changelogAlert() {
            axios.post(`/api/newVersion`, { data: 1 }).then((response) => {
                this.$toast.success(this.$t("changelog.text_0"), {
                    timeout: 2038,
                });
            });
        },
    },
};
</script>

<style lang="scss">
.change_log {
    label {
        text-transform: none;
        width: 100px;
        height: 20px;
        display: flex;
        align-items: center;
        justify-content: center;
    }
    p {
        width: 80%;
        a {
            color: #f3385a;
            text-decoration: underline;
        }
    }
    .label-change {
        background-color: #aa336a;
    }
}
</style>
